import script from "./Grafico.vue?vue&type=script&setup=true&lang=js"
export * from "./Grafico.vue?vue&type=script&setup=true&lang=js"

import "./Grafico.vue?vue&type=style&index=0&id=4427aa9d&lang=css"

const __exports__ = script;

export default __exports__